import React from 'react'

import { Card, CardContent, CardHeader } from '@mui/material'

import { SimpleTable } from 'components/table'

const config = [
  {
    title: 'Range',
    render: ({ from, to }: any) => `${from} – ${to}`,
  },
]

type CompanyIpRangesProps = {
  ipRanges: any
}

const CompanyIpRanges = ({ ipRanges }: CompanyIpRangesProps) => {
  return (
    <Card>
      <CardHeader title="IP Ranges" />
      <CardContent>
        <SimpleTable config={config} data={ipRanges} />
      </CardContent>
    </Card>
  )
}

export default CompanyIpRanges
